import {ReactElement} from "react";
import {StyledBoxColumn} from "../../shared/StyledComponents";
import {Page} from "../types";
import {Typography} from "@mui/material";
import {StoredDataFileUploadFragment} from "../../shared/StoredDateFileUploadFragment";
import {DIVIDER} from "../../shared/dimens";

export default function ProviderPageVerificationIdentity({page, value, setValue}: {
  page: Page,
  value: string,
  setValue: (url: string) => void
}): ReactElement {
  return <StyledBoxColumn>
    <Typography variant="h6">{page.providerPageProfile.basicInfo.displayName()}</Typography>
    <StoredDataFileUploadFragment
      style={{border: DIVIDER}}
      mimeTypes={["image/*"]}
      storedDataSource={"provider-page-verifications"}
      initialUrls={value ? [value] : undefined}
      onUploadDone={(urls: string[]) => {
        setValue(urls[0]);
      }}/>
    <Typography variant={"body2"}>
      Please upload your identify proof to ensure that you retain ownership of your profile page.
      <br/>
      <br/>
      Acceptable documents:
      <ul>
        <li>Aadhaar Card</li>
        <li>Driver's License</li>
        <li>Voter Card</li>
        <li>Government-issued ID</li>
      </ul>
    </Typography>
  </StyledBoxColumn>
}

export function renderProviderPageVerificationIdentity(page: Page, value: string, setValue: (url: string) => void): ReactElement {
  return <ProviderPageVerificationIdentity page={page} value={value} setValue={setValue}/>;
}